import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { gtmPush } from 'cityads-v3/utils/counterUtils';

export default function GTMUserIdentifier() {
  const userID = useSelector(state => state.auth.user?.id);

  useEffect(() => {
    if (userID) {
      gtmPush({
        userID
      });
    }
  }, [userID]);

  return null;
}
